


















































































import Vue, { PropOptions } from 'vue'
import cloneDeep from 'lodash/cloneDeep'
import intersection from 'lodash/intersection'

import {
  SearchParamModel,
  SearchFacets,
  FacetValuesType,
  PrintingMethodsCount,
  IndustryValue,
  EditPattern
} from '@/search/types'
import { ProductCategory } from '@/model/productCategory'

import ModalSimple from '@/common/components/ModalSimple.vue'
import Category from '@/search/components/paramModalSections/Category.vue'
import PrintingMethod from '@/search/components/paramModalSections/PrintingMethod.vue'
import Facets from '@/search/components/paramModalSections/Facets.vue'
import PriceRange from '@/search/components/paramModalSections/PriceRange.vue'
import FilterIndustry from '@/search/components/FilterIndustry.vue'
import EditPatterns from '@/search/components/paramModalSections/EditPatterns.vue'
import CategoryModal from '@/search/components/paramModalSections/CategoryModal.vue'

import { estimateSearchProducts } from '@/search/services'
import { NUMBER_ITEM_PER_PAGE, DEFAULT_SORT_ORDER } from '@/search/const'
export default Vue.extend({
  components: {
    ModalSimple,
    Category,
    PrintingMethod,
    Facets,
    PriceRange,
    FilterIndustry,
    EditPatterns,
    CategoryModal
  },
  props: {
    initParams: {
      type: Object,
      required: true
    } as PropOptions<SearchParamModel>,
    minUnitPrice: {
      type: Number,
      required: true
    },
    maxUnitPrice: {
      type: Number,
      required: true
    },
    currentResult: {
      type: Number,
      required: true
    },
    productCategory: {
      type: Array as () => Array<ProductCategory>,
      required: true
    },
    productCategoryName: {
      type: String,
      required: true
    },
    productCategoryCount: {
      type: Object,
      required: true
    },
    printingMethodsCount: {
      type: Object,
      required: true
    } as PropOptions<PrintingMethodsCount>,
    searchFacets: {
      type: Array,
      required: true
    } as PropOptions<SearchFacets[]>,
    tagFacets: {
      type: Array,
      required: true
    } as PropOptions<any>,
    industries: {
      type: Array,
      required: true
    } as PropOptions<IndustryValue[]>,
    editPatternList: {
      type: Array as () => EditPattern[],
      required: true
    }
  },
  data(): {
    selectCategoryVisible: boolean
    modifyParams: SearchParamModel
    expectResult: number
    categoryName: string
    errorMessage: string
  } {
    return {
      selectCategoryVisible: false,
      modifyParams: cloneDeep(this.initParams),
      expectResult: this.currentResult,
      categoryName: '',
      errorMessage: ''
    }
  },
  computed: {
    disableButton(): boolean {
      return this.errorMessage != ''
    },
    selectedCategoryName(): string {
      return this.categoryName || this.productCategoryName
    },
    formatFacets(): Array<FacetValuesType> {
      const facets: FacetValuesType[] = []
      let facetValueNames = this.modifyParams.facetValueNames
      for (let facet of this.searchFacets) {
        if (facetValueNames.length === 0) break
        const facetValues = facet.facetValues.map(value => value.facetValueName)
        const selectedValues = intersection(facetValueNames, facetValues)
        if (selectedValues) {
          facets.push({
            facetKey: facet.facetKeyName,
            facetValues: selectedValues
          })
          facetValueNames = facetValueNames.filter(item => !selectedValues.includes(item))
        }
      }
      return facets
    }
  },
  mounted() {
    if (!this.modifyParams.maxUnitPrice) {
      this.modifyParams.maxUnitPrice = this.maxUnitPrice
    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
    clearAllSearchParam(){
      this.modifyParams.categoryId = null
      this.categoryName = ''
      this.modifyParams.minUnitPrice = this.minUnitPrice
      this.modifyParams.maxUnitPrice = this.maxUnitPrice
      this.modifyParams.printingMethods = []
      this.modifyParams.facetValueNames = []
      this.closeModal()
      this.applyChange()
    },
    onSelectCategory(category: { id: number; name: string }) {
      this.categoryName = category.name
      this.updateParams({
        categoryId: category.id
      })
    },
    validateInput() {
      let error = ''
      if (isNaN(this.modifyParams.minUnitPrice) ||
        isNaN(this.modifyParams.maxUnitPrice)) {
        error =  '半角数字で入力してください'
      } else if (this.modifyParams.maxUnitPrice > this.maxUnitPrice ||
        this.modifyParams.minUnitPrice > this.modifyParams.maxUnitPrice ){
        error =  '最小値は最大値より低いです。'
      }
      this.errorMessage = error
    },
    updateParams(payload: { [key: string]: string | number | string[] | number[]}) {
      Object.assign(this.modifyParams, payload)
      this.estimateTotalItemsCount()
    },
    onChangePriceRange(payload: { [key: string]: string | number | string[]}) {
      Object.assign(this.modifyParams, payload)
      this.validateInput()
      if (!this.errorMessage) {
        this.estimateTotalItemsCount()
      }
    },
    searchPayloadHandler(): {
      [key: string]: string | string[] | number | null | Array<FacetValuesType> | number[]
    } {
      return {
        categoryId: this.modifyParams.categoryId as string,
        minUnitPrice: this.modifyParams.minUnitPrice || this.minUnitPrice,
        maxUnitPrice: this.modifyParams.maxUnitPrice || this.maxUnitPrice,
        printingMethods: this.modifyParams.printingMethods,
        facets: this.formatFacets,
        industryIds: this.modifyParams.industryIds
      }
    },
    async estimateTotalItemsCount() {
      if (this.errorMessage) return
      const searchPayload = this.searchPayloadHandler()
      const res = await estimateSearchProducts({
        ...searchPayload,
        offset: 0,
        limit: NUMBER_ITEM_PER_PAGE,
        sortOrder: DEFAULT_SORT_ORDER,
        keyword: this.modifyParams.keyword,
        userDesignVersionUuid: this.modifyParams.userDesignVersionUuid,
        editPatterns: this.modifyParams.editPatterns
      }).catch(err => {
        throw err
      })
      if (res?.data) {
        this.expectResult = res.data.productSearch?.totalItemsCount
      }
    },
    applyChange() {
      this.$emit('updateSearchParams', this.modifyParams)
    },
    industriesHandler(params: {ids: number[]}) {
      this.updateParams({ industryIds: params.ids })
    },
    openCategoryModal() {
      this.selectCategoryVisible = true
    }
  }
})
